import { Component } from '@angular/core';

@Component({
  selector: 'app-sso-left-website',
  templateUrl: './sso-left-website.component.html',
  styleUrls: ['./sso-left-website.component.scss'],
})
export class SsoLeftWebsiteComponent {}
